import styled from '@emotion/styled';
import { Wws_Page } from '../../../../../types/graphql';
import {
  getSectionId,
  handleSinglePageSectionScrolling,
} from '../../../../Templates/SinglePageTemplate';
import Link from 'next/link';
import { useRouteBuilder } from '../../../../../lib/hooks/useRouteBuilder';

interface NavMenuItemProps {
  isActive?: boolean;
}
const NavMenuItem = styled('div')`
  display: flex;
  font-weight: ${({ isActive }: NavMenuItemProps): string =>
    isActive ? '700' : 'initial'};
  text-decoration: ${({ isActive }: NavMenuItemProps): string =>
    isActive ? 'underline' : 'none'};
  text-underline-offset: 4px;
  font-size: 22px;
  text-align: left;
  width: 100%;

  &:hover {
    font-weight: 700;
  }
`;

const StyledLink = styled(Link)`
  flex: 1;
  color: inherit;
`;

interface SinglePageDesktopNavMenuItemProps {
  page: Wws_Page;
  isActive: boolean;
  onClick: () => void;
  handleTracking: (newRoute: string) => void;
}
const SinglePageDesktopNavMenuItem = ({
  page,
  isActive,
  onClick,
  handleTracking,
}: SinglePageDesktopNavMenuItemProps) => {
  const newRoute = useRouteBuilder(page.routeName || '');

  const onItemClick = () => {
    const sectionId = getSectionId(page);

    handleTracking(sectionId);

    handleSinglePageSectionScrolling(sectionId);

    onClick();
  };

  return (
    <NavMenuItem
      key={page.id}
      onClick={onItemClick}
      isActive={isActive}
      data-testid={`nav-menu-item-${getSectionId(page)}`}
    >
      <StyledLink href={newRoute} scroll={false}>
        {page.title}
      </StyledLink>
    </NavMenuItem>
  );
};
export default SinglePageDesktopNavMenuItem;
